module.exports = __webpack_public_path__ + "img/xiang2.87615a90.png";